document.addEventListener("DOMContentLoaded", function () {
    let tabs = document.querySelectorAll(".tab-link");
    let contents = document.querySelectorAll(".tab-content");

    tabs.forEach((tab, index) => {
        tab.addEventListener("click", function () {
            // Remove 'current' class from all tabs
            tabs.forEach((t) => t.classList.remove("current"));
            contents.forEach((c) => c.classList.remove("current"));

            // Add 'current' class to the clicked tab and corresponding content
            this.classList.add("current");
            contents[index].classList.add("current");
        });
    });



    $(document).on('click', '.product__page [data-popout-option]', function (e) {
      e.preventDefault();
    
      var $option = $(this);
      var $popout = $option.closest('.select-popout');
      var $toggleText = $popout.find('[data-popout-toggle-text]');
      var $input = $popout.find('[data-popout-input]');
    
      var fullText = $option.find('span').text().trim();
    
      $toggleText.text(fullText);
    
      var selectedValue = $option.data('value');
      $input.val(selectedValue);
    
      $popout.find('.select-popout__item').removeClass('is-active');
      $option.closest('li').addClass('is-active');
    });

  
});
